import { createHOC } from 'vue-hoc';
import omit from 'lodash/omit';

import { groupsDataKey } from '../providers/auth';

export default function withOrgs() {
  return (Component) => {
    const options = {
      name: Component.name + '-with-orgs',
    };

    const renderWith = {
      props: {
        orgs() {
          const groupsData = JSON.parse(localStorage.getItem(groupsDataKey));
          return groupsData.filter((group) => !group.metadata.parent);
        },
      },
    };

    const AugmentedComponent = createHOC(Component, options, renderWith);    
    AugmentedComponent.props = omit(AugmentedComponent.props, 'orgs');
    return AugmentedComponent;
  };
}
